
export const fieldsConfig = [
  {
    name: "iana_name",
    label: "IANA Name",
    type: "text",
    required: true,
  },
  {
    name: "display_name",
    label: "Display Name",
    type: "text",
    required: true,
  },
  {
    name: "utc_offset",
    label: "UTC Offset",
    type: "text",
    required: true,
  },
  {
    name: "abbreviation",
    label: "Abbreviation",
    type: "text",
  },
];
